import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { useCallback, useMemo } from 'react';
import { isNotDefined, listToGroupList } from '@togglecorp/fujs';
import Border from './Border/index.js';
import { genericMemo } from '../utils/index.js';

const emptyList = [];

function NonGroupedList(props) {
  var _Border;

  const {
    data: dataFromProps,
    keySelector,
    renderer: Renderer,
    rendererClassName,
    rendererParams,
    spacing = 'comfortable',
    borderBetweenItem,
    borderBetweenItemClassName,
    borderBetweenItemWidth = 'thin',
    indexOffset = 0
  } = props;
  const data = dataFromProps ?? emptyList;
  const renderListItem = useCallback((datum, i) => {
    const actualIndex = i + indexOffset;
    const key = keySelector(datum, actualIndex);
    const extraProps = rendererParams(key, datum, actualIndex, data);

    if (isNotDefined(extraProps)) {
      return null;
    }

    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: key
    }, /*#__PURE__*/React.createElement(Renderer, _extends({
      className: rendererClassName
    }, extraProps)), borderBetweenItem && data.length > actualIndex + 1 && (_Border || (_Border = /*#__PURE__*/React.createElement(Border, {
      inline: true,
      extendToSpacing: true,
      spacing: spacing,
      className: borderBetweenItemClassName,
      width: borderBetweenItemWidth
    }))));
  }, [keySelector, indexOffset, Renderer, rendererClassName, rendererParams, data, spacing, borderBetweenItem, borderBetweenItemWidth, borderBetweenItemClassName]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, data.map(renderListItem));
} // eslint-disable-next-line max-len


function GroupedList(props) {
  var _Border2;

  const {
    groupKeySelector,
    groupComparator,
    renderer: Renderer,
    groupRenderer: GroupRenderer,
    groupRendererClassName,
    groupRendererParams,
    data: dataFromProps,
    keySelector,
    rendererParams,
    rendererClassName,
    spacing = 'comfortable',
    borderBetweenItem,
    borderBetweenItemWidth = 'thin',
    borderBetweenItemClassName
  } = props;
  const data = dataFromProps ?? emptyList;
  const renderListItem = useCallback((datum, i) => {
    const key = keySelector(datum, i);
    const extraProps = rendererParams(key, datum, i, data);

    if (isNotDefined(extraProps)) {
      return null;
    }

    return /*#__PURE__*/React.createElement("div", {
      key: key
    }, /*#__PURE__*/React.createElement(Renderer, _extends({
      className: rendererClassName
    }, extraProps)), borderBetweenItem && data.length > i + 1 && (_Border2 || (_Border2 = /*#__PURE__*/React.createElement(Border, {
      inline: true,
      extendToSpacing: true,
      spacing: spacing,
      className: borderBetweenItemClassName,
      width: borderBetweenItemWidth
    }))));
  }, [Renderer, data, keySelector, rendererClassName, rendererParams, borderBetweenItem, borderBetweenItemClassName, borderBetweenItemWidth, spacing]);

  const renderGroup = (groupKey, index, groupData, children) => {
    const extraProps = groupRendererParams(groupKey, index, groupData);

    if (isNotDefined(extraProps)) {
      return null;
    }

    const finalProps = { ...extraProps,
      className: groupRendererClassName,
      children
    };
    return /*#__PURE__*/React.createElement(GroupRenderer, _extends({
      key: groupKey // FIXME: currently typescript is not smart enough to join Omit

    }, finalProps));
  };

  const groups = useMemo(() => listToGroupList(data, groupKeySelector), [data, groupKeySelector]);
  const sortedGroupKeys = useMemo(() => {
    const keys = Object.keys(groups);
    return keys.sort(groupComparator);
  }, [groups, groupComparator]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-useless-fragment
    React.createElement(React.Fragment, null, sortedGroupKeys.map((groupKey, i) => renderGroup(groupKey, i, groups[groupKey], groups[groupKey].map(renderListItem))))
  );
}

function List(props) {
  // eslint-disable-next-line react/destructuring-assignment
  if (!props.grouped) {
    return /*#__PURE__*/React.createElement(NonGroupedList, props);
  }

  return /*#__PURE__*/React.createElement(GroupedList, props);
}

var List$1 = genericMemo(List);

export { List$1 as default };
//# sourceMappingURL=List.js.map
